module.exports = __webpack_public_path__ + "img/customercommentBg.280d54dd.png";